import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {EmailMakerBannerStyle} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/email-maker-plugin.types';
import type {BannerStripProps} from './banner-strip.types';
import styles from './banner-strip.module.scss';

const BANNER_STYLE_CLASS_MAP: Record<EmailMakerBannerStyle, string> = {
  [EmailMakerBannerStyle.ERROR]: styles.bannerError,
  [EmailMakerBannerStyle.WARNING]: styles.bannerWarning,
  [EmailMakerBannerStyle.SUCCESS]: styles.bannerSuccess,
  [EmailMakerBannerStyle.INFO]: styles.bannerInfo,
  [EmailMakerBannerStyle.AI]: styles.bannerAi,
};

function renderIcon(icon: string | undefined): ReactElement | null {
  if (icon === undefined) {
    return null;
  }
  return <Icon icon={icon} size={IconSize.SIZE_ICON_20} ariaHidden />;
}

function renderCtaButton(cta: VoidFunction | undefined, ctaText: string | undefined): ReactElement | null {
  if (!cta || !ctaText) {
    return null;
  }
  return (
    <button className={styles.ctaButton} onClick={cta} type="button">
      {ctaText}
    </button>
  );
}

export function BannerStrip({message, style, icon, cta, ctaText}: BannerStripProps): ReactElement {
  const styleClass = BANNER_STYLE_CLASS_MAP[style];
  return (
    <div className={`${styles.banner} ${styleClass}`} role="status" aria-live="polite">
      {renderIcon(icon)}
      <Text val={message} size={TextSize.MD} className={styles.message} />
      {renderCtaButton(cta, ctaText)}
    </div>
  );
}
